module.exports = __webpack_public_path__ + "img/ZEIT-alt.41559731.svg";